export enum InsertionTypes {
  newInsertion = 'new',
  returnInsertion = 'return',
  boosterInsertion = 'booster',
  replacementInsertion = 'replacement',
  all = 'all',
}
